import { Divider, Link, List, ListItem, Typography } from "../../atom";
import css from "./Stepper.module.css";

export type IStepProps = {
  href: string;
  title: string;
};

export interface IStepperProps {
  currentStep?: number;
  title?: string;
  options: Array<IStepProps>;
  showDivider?: boolean;
}

const BASE_CLASS = "f-OrganismStepper";

export const Stepper = ({
  currentStep = 1,
  title,
  options,
  showDivider = false,
}: IStepperProps) => {
  if (!options.length) return null;

  const renderItem = (option: IStepProps, index: number) => {
    const currentIndex = index + 1;
    const text = `${currentIndex}. ${option.title}`;
    const slug = option.href.replace("/", "");
    const elementKey = `${slug}-${currentIndex}`;

    return (
      <ListItem hideIcon key={elementKey}>
        {currentStep === currentIndex ? (
          <Typography as="strong">{text}</Typography>
        ) : (
          <Link href={option.href}>{text}</Link>
        )}
      </ListItem>
    );
  };

  return (
    <div className={css[BASE_CLASS]}>
      {showDivider && <Divider />}
      {title && <Typography as="h3">{title}</Typography>}
      <List type="listbox" ariaLabel="Lista de artículos relacionados">
        {options.map(renderItem)}
      </List>
    </div>
  );
};
